import {
    allFetch
} from "../Domain";

/**
 * @description 取得API的中文名稱
 */
export const GetApiInfo = (() => {
    /**
     * 
     * @param {*} apiUrl api 路徑
     * @returns 
     */
    const GetApiName = async function (apiUrl) {
        if (apiUrl === null) return {
            api_name: "查無 API 名稱",
            keys: []
        };
        else {
            // 拆解拿到的 api 路徑
            apiUrl = apiUrl.substr(0, 1) == "/" ? apiUrl.substr(1, apiUrl.length) : apiUrl;
            // api controlller
            let api_controlller = apiUrl.split("/")[0];
            // api 名稱
            let api_name = apiUrl.split("/")[1];
            // 呼叫對應的方選
            let api = await eval(api_controlller + "." + api_name + "_Info();");
            return api;
        };
    }
    return {
        GetApiName
    }
})();